/* NukkadTales — Ask Gul drawer logic
   Runs inside the /pages/ask-gul iframe (layout: ask-gul).
   Sprite URL comes from window.NT_GUL_SPR13 (set by the layout).
   All onclick handlers in the section markup call these globals.
*/
(function () {
  'use strict';

  /* Inline-drawer mode (embedded in page) vs. standalone /pages/ask-gul */
  const embedded = !!(document.getElementById('agOverlay'));

  /* ═══ URL PARAMS ═══ */
  const P = new URLSearchParams(location.search);
  const INIT_INTENT = P.get('intent'), INIT_Q = P.get('q');

  /* ═══ DATA ═══ */
  const INTENT_DATA = {
    gift:{prefix:"gift for",ctx:["Maa","Papa","Partner","Bestie","Sibling","Boss","Teacher"]},
    decor:{prefix:"decor for",ctx:["Living room","Bedroom","Desk","Pooja room","Entryway","Kitchen"]},
    self:{prefix:"something",ctx:["Calm","Grateful","Motivated","Funny","Homebody","Dreamer"]}
  };
  const SITUATIONS = [
    {label:'A quiet thank you', q:'a quiet thank you, nothing too loud'},
    {label:'My first home',     q:'moving into my first home'},
    {label:'A tough year',      q:'someone who had a tough year'},
    {label:'Something funny',   q:'something funny and lighthearted'},
    {label:'For my team',       q:'something for my team at work'},
    {label:'No idea yet',       q:'no idea, just find me something good'}
  ];
  const HINTS = {
    default:{text:"Tell me who it’s for —", eg:'e.g. “Maa, loves gardening”'},
    gift:{text:"Add the occasion & what they love —", eg:'e.g. “Papa’s 60th, cricket fan”'},
    decor:{text:"The room & the mood —", eg:'e.g. “cozy bedroom, earthy”'},
    self:{text:"Your vibe & what you love —", eg:'e.g. “slow mornings, chai”'}
  };
  /* keyword → real Shopify collection handle — edit this to add/change mappings */
  const COLLECTION_MAP=[
    /* ── FAMILY ── */
    {keys:['maa','mummy','mom','amma','mother','maata'],                       c:'for-family'},
    {keys:['papa','dad','father','pita','abba','paa','baap'],                  c:'for-father'},
    {keys:['son','beta','bete','boy'],                                         c:'for-family'},
    {keys:['daughter','beti','bete','girl'],                                   c:'for-family'},
    {keys:['dada','dadi','nana','nani','grandpa','grandma','grandfather','grandmother','daadi','naani'], c:'for-family'},
    {keys:['chacha','chachi','tauji','tai','bua','buaji','fufa','fufaji','uncle','aunty'],              c:'for-family'},
    {keys:['mama','mami','mausa','mausi','masi'],                              c:'for-family'},
    {keys:['saas','sasur','in-law','inlaw','jiju','bhabhi','devar','nanad'],   c:'for-family'},
    /* ── COUPLE / ROMANCE ── */
    {keys:['girlfriend','wife','biwi'],                                        c:'for-girlfriend-wife'},
    {keys:['boyfriend','husband','pati'],                                      c:'for-boyfriend-husband'},
    {keys:['couple','partner','love','jaan','anniversary','wedding','dulha','dulhan','shaadi'], c:'for-couple'},
    /* ── SIBLINGS ── */
    {keys:['sibling','bhai','behen','sister','brother','rakhi','rakshabandhan'], c:'siblings'},
    /* ── FRIENDS ── */
    {keys:['friend','bestie','dost','yaar','buddy'],                           c:'for-friends'},
    /* ── PROFESSIONAL ── */
    {keys:['boss','manager','senior','sir','madam'],                           c:'for-boss'},
    {keys:['colleague','coworker','team','teammate','office friend'],          c:'for-boss'},
    {keys:['teacher','guru','professor','mentor','coach'],                     c:'thoughtful-and-unique-gifts'},
    {keys:['doctor','engineer','lawyer','ca','pilot','architect','designer','coder','developer'], c:'thoughtful-and-unique-gifts'},
    /* ── OCCASIONS ── */
    {keys:['birthday'],                                                        c:'birthday-sale-1'},
    {keys:['retirement','farewell','goodbye','leaving'],                       c:'motivational'},
    {keys:['promotion','new job','achievement','graduation','convocation'],    c:'motivational'},
    {keys:['housewarming','new home','ghar'],                                  c:'home-decor'},
    {keys:['diwali','holi','eid','christmas','festival','celebration'],        c:'thoughtful-and-unique-gifts'},
    /* ── DECOR ── */
    {keys:['desk','office decor','workspace'],                                 c:'office-decor'},
    {keys:['kitchen'],                                                         c:'kitchen-decor'},
    {keys:['study','reading','library'],                                       c:'study-decor'},
    {keys:['bedroom','room','wall'],                                           c:'home-decor'},
    {keys:['home','living','hall','drawing room','lounge'],                    c:'home-decor'},
    /* ── VIBE ── */
    {keys:['motivat','hustle','dream','shine','goal','ambition'],              c:'motivational'},
    {keys:['religious','spiritual','mantra','prayer','bhakti','pooja'],        c:'religious-spiritual-quotes'},
    {keys:['hindi','shayari','urdu'],                                          c:'hindi'},
    {keys:['funny','humor','laugh','comedy','sarcastic'],                      c:'unisex'},
    {keys:['chai','calm','peace','sukoon','slow','mindful','relax'],           c:'mantra'},
    {keys:['personalise','custom','name','engrave'],                          c:'personalisation'},
    {keys:['work','office'],                                                   c:'office-decor'},
    {keys:['gift','gifting'],                                                  c:'thoughtful-and-unique-gifts'},
  ];
  const DEFAULT_COLLECTION='bestseller';
  function matchCollection(val){
    const v=(val||'').toLowerCase();
    for(const row of COLLECTION_MAP) for(const k of row.keys) if(v.includes(k)) return row.c;
    return null;
  }

  /* Extract the meaningful recipient/theme from the query.
     Prefers known recipient words (son, maa, partner...) over the naive last-word. */
  function extractWhom(val){
    const v=(val||'').toLowerCase();
    for(const row of COLLECTION_MAP) for(const k of row.keys) if(v.includes(k)) return k;
    const forM=v.match(/\bfor\s+m[ey]\s+(\w+)|\bfor\s+(\w+)/);
    if(forM) return forM[1]||forM[2];
    return v.split(/[ ,]+/).pop()||v;
  }
  /* Build a human-readable label, appending interest when "who loves X" is detected */
  function buildLabel(val, whom){
    const v=(val||'').toLowerCase();
    const m=v.match(/(?:who\s+)?loves?\s+([a-z][a-z ]{1,18}?)(?:\s*,|\s*\.|$)|into\s+([a-z][a-z ]{1,18}?)(?:\s*,|\s*\.|$)/);
    if(m){
      const interest=((m[1]||m[2])||'').trim().replace(/\s+/g,' ');
      if(interest&&interest!==whom&&interest.length>=3) return `tales for ${whom}, ${interest} lover`;
    }
    return `tales for ${whom}`;
  }
  const INTRO_TXT = "Hi, I'm Gul! Tell me who it's for — a name, a room, or a feeling — and I'll find the perfect tale.";

  const QTPL = {
    parent:["{C} — my first hero","Few words, a lifetime of love","Home is wherever {C} is","To {C}, with everything I am","My roots, my reason","The love that asked for nothing","All I am, because of you","Thank you — for everything"],
    partner:["You, me, this little home","Better, because of you","Two hearts, one address","Still us, still here","Where you are is home","Built a life, kept the love","My favourite hello","To us — and all the rest"],
    friend:["The family I chose","Some friends become forever","Through it all — you","My person, always","Distance changes nothing","Found family, kept close","Partners in everything","Cheers to the chaos"],
    calm:["Breathe. You're home now","Slow mornings, full heart","Sukoon lives in this corner","Let it be soft","Stillness is a gift","Peace, one cup at a time","One breath at a time","Home is a feeling"],
    motivate:["Apna time aayega","Keep going — you're closer","Born to shine, made to rise","Dream bigger, doubt less","One day, or day one","Rise. Again. Always","Trust the timing","Small steps, big dreams"],
    generic:["Words that outlast the wall","A little reminder, every day","Carved with intention","Something that simply stays","Your story, on the wall","Made for this moment","Read it and smile","A story worth keeping"]
  };
  function quoteCat(q){q=(q||'').toLowerCase();
    if(/maa|mom|mummy|amma|mother|papa|dad|father|pita|abba|paa|sibling|son|daughter|bhai|behen/.test(q))return 'parent';
    if(/partner|husband|wife|love|jaan|hubby|wifey|bf|gf|boyfriend|girlfriend/.test(q))return 'partner';
    if(/bestie|friend|dost|yaar|bff|boss|teacher/.test(q))return 'friend';
    if(/calm|peace|sukoon|slow|chai|cozy|cosi|relax|grateful|homebody|bedroom|pooja/.test(q))return 'calm';
    if(/motiv|dream|shine|hustle|goal|success|grind|desk|office|work/.test(q))return 'motivate';
    return 'generic';
  }
  function moreCount(q){let h=0;const s=q||'tales';for(let i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))>>>0;return 18+(h%30);}

  /* ═══ SPRITE — live state machine (mini always + big during intro) ═══ */
  let gulImg = null;
  let _miniCvs = null, _bigCvs = null, _bigActive = false;
  let _loopOn = false, _lastF = -1;
  let gulMode = 'idle', _modeStart = 0, _modeUntil = 0;

  function drawF(cvs, f){
    if(!gulImg || !cvs) return;
    const fw = gulImg.naturalWidth / 13;
    const c = cvs.getContext('2d');
    c.clearRect(0, 0, cvs.width, cvs.height);
    c.drawImage(gulImg, f*fw, 0, fw, gulImg.naturalHeight, 0, 0, cvs.width, cvs.height);
  }
  function setMode(m, ms){ gulMode = m; _modeStart = performance.now(); _modeUntil = _modeStart + (ms||0); }
  function frameFor(t){
    const e = t - _modeStart;
    /* REACT — wings up, then happy, then settle */
    if(gulMode === 'react'){
      if(t < _modeUntil) return e < 430 ? 4 : (e < 660 ? 3 : 4);
      gulMode='idle'; _modeStart=t;
    }
    /* TALK — lively bob + happy + blink while she speaks */
    if(gulMode === 'talk'){
      if(t < _modeUntil){
        const seq=[0,1,3,1,0,2];
        return seq[Math.floor(e/140) % seq.length];
      }
      gulMode='idle'; _modeStart=t;
    }
    /* IDLE — gentle blinks + occasional glance, on a 4s loop */
    const c = (t - _modeStart + 600) % 4000;
    if(c < 130) return 2;
    if(c > 1700 && c < 1830) return 2;
    if(c > 2650 && c < 3200) return 1;
    return 0;
  }
  function gulLoop(){
    if(!_loopOn) return;
    const t = performance.now();
    const f = frameFor(t);
    if(f !== _lastF){
      if(_miniCvs && gulImg) drawF(_miniCvs, f);
      if(_bigCvs && gulImg && _bigActive) drawF(_bigCvs, f);
      _lastF = f;
    }
    requestAnimationFrame(gulLoop);
  }
  function startLoop(){ if(!_loopOn){ _loopOn=true; requestAnimationFrame(gulLoop); } }
  function gulReact(){ setMode('react', 880); chirp(); setTimeout(chirp, 150); }
  document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) _lastF=-1; });

  /* ═══ GUL PIP — click reaction ═══ */
  function pipTap(){
    const inp = document.getElementById('inpF');
    if (inp) inp.focus();
    flash("Type who it's for, then tap Ask Gul.");
  }

  /* ═══ GUL VOICE — real bird chirp (same engine as the homepage hero) ═══ */
  let _AC=null;
  function ac(){if(!_AC){try{_AC=new (window.AudioContext||window.webkitAudioContext)();}catch(e){}}if(_AC&&_AC.state==='suspended')_AC.resume();return _AC;}
  const VOL=(window.matchMedia&&matchMedia('(pointer:coarse)').matches)?1.8:1;
  function _unlock(){const a=ac();if(a){try{const b=a.createBuffer(1,1,22050);const s=a.createBufferSource();s.buffer=b;s.connect(a.destination);s.start(0);}catch(e){}}}
  ['pointerdown','touchstart','click','keydown'].forEach(ev=>addEventListener(ev,_unlock,{passive:true}));
  function chirp(){
    const a=ac(); if(!a||a.state!=='running') return;
    const t=a.currentTime;
    const o=a.createOscillator(), g=a.createGain();
    const f=2300+Math.random()*900; o.type='sine';
    o.frequency.setValueAtTime(f,t);
    o.frequency.exponentialRampToValueAtTime(f*1.6,t+0.032);
    o.frequency.exponentialRampToValueAtTime(f*0.82,t+0.066);
    g.gain.setValueAtTime(0.0001,t);
    g.gain.exponentialRampToValueAtTime(0.048*VOL,t+0.01);
    g.gain.exponentialRampToValueAtTime(0.0001,t+0.075);
    o.connect(g); g.connect(a.destination); o.start(t); o.stop(t+0.09);
  }

  /* ═══ TYPEWRITER ═══ */
  let typT = null;
  function typeText(txt, cb){
    clearTimeout(typT);
    const el = document.getElementById('gulText'), cr = document.getElementById('bcursor');
    if(!el) return;
    el.textContent=''; if(cr) cr.style.display='inline-block';
    const dur = txt.length*27+350;
    setMode('talk', dur);
    let i=0;
    (function step(){
      el.textContent = txt.slice(0,i);
      const ch = txt[i-1];
      if(ch && 'aeiouAEIOU'.includes(ch) && Math.random()<0.82) chirp();
      if(i++ <= txt.length) typT = setTimeout(step, 27);
      else{ if(cr) cr.style.display='none'; cb&&cb(); }
    })();
  }



  /* ═══ LIVE SEARCH — Netlify anthropic fn (Gemini matcher over real catalog) ═══ */
  /* Two deploys of the same function — try cozy first, fall back to the
     legendary-selkie site the intent gate uses in production */
  const NT_API_URLS=[
    'https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/anthropic',
    'https://legendary-selkie-d0c7dd.netlify.app/.netlify/functions/anthropic'
  ];

  /* ═══ GUL ENGAGEMENT TRACKING ═══ */
  window._gulCalledThisSession = false;
  window._trackGulEvent = function(type, query) {
    try {
      var sid = sessionStorage.getItem('nt_sid') || (function () {
        var s = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('nt_sid', s);
        return s;
      })();
      fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-gul-stats', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_type: type, session_id: sid, query: query || null })
      }).catch(function () {});
    } catch (e) {}
  };
  function searchAPI(query){
    let chain=Promise.reject();
    NT_API_URLS.forEach(url=>{
      chain=chain.catch(()=>
        fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,count:20})})
          .then(r=>r.json())
          .then(data=>{
            if(data.error) throw new Error(typeof data.error==='string'?data.error:(data.error.message||'API error'));
            const text=(data.content&&data.content[0]&&data.content[0].text)||'[]';
            const jm=text.replace(/```json|```/g,'').trim().match(/\[[\s\S]*\]/);
            let matches=[]; if(jm){try{matches=JSON.parse(jm[0]);}catch(e){}}
            matches=matches.filter(m=>m&&m.handle);
            if(!matches.length) throw new Error('no matches in response');
            console.log('[NT-AG] live search OK via',url.split('//')[1].split('.')[0],'—',matches.length,'matches');
            return matches;
          })
          .catch(err=>{console.warn('[NT-AG] search failed on',url,'—',err&&err.message);throw err;})
      );
    });
    return chain;
  }
  const LIVE_BATCH=8;
  let LIVE={matches:[],shown:0,whom:''};
  /* public storefront product JSON — same origin, no auth needed */
  const PRODCACHE={};
  /* search history tabs — every search (AI or collection) is saved + tagged with a pill.
     Persisted to localStorage so pills survive reloads; newest first, max 8, deduped by label. */
  let SEARCH_TABS=[];
  try{SEARCH_TABS=JSON.parse(localStorage.getItem('nt_ag_tabs')||'[]')||[];}catch(e){SEARCH_TABS=[];}
  let CUR_TAB_ID=null;  // tab currently displayed (null = fresh live results)
  let LIVE_TAB_ID=null; // tab id being built by the ongoing live search
  function saveTabs(){try{localStorage.setItem('nt_ag_tabs',JSON.stringify(SEARCH_TABS.slice(0,8)));}catch(e){}}
  function fetchProducts(handles){
    const out={};
    return Promise.all(handles.map(h=>{
      const pData=fetch('/products/'+h+'.json').then(r=>r.json());
      /* Fetch admin-configured swatch colours — same source as nt-card.liquid */
      const pSwatch=fetch('/products/'+h+'?view=nt-swatches')
        .then(r=>r.text()).then(t=>{try{return JSON.parse(t.trim());}catch(e){return {};}}).catch(()=>({}));
      return Promise.all([pData,pSwatch]).then(([d,sw])=>{
        if(d&&d.product){const p=d.product;
          out[h]={img:(p.images&&p.images[0]&&p.images[0].src)||'',
                  price:p.variants&&p.variants[0]?Math.round(parseFloat(p.variants[0].price)):0,
                  title:p.title,id:p.id,
                  options:(p.options||[]).map(o=>o.name||o),
                  swatches:(sw&&sw.c)||{},
                  variants:(p.variants||[]).map(v=>({id:v.id,title:v.title,option1:v.option1,option2:v.option2,option3:v.option3,price:Math.round(parseFloat(v.price))||0}))};
          PRODCACHE[h]=out[h];}
      }).catch(()=>{});
    })).then(()=>out);
  }
  function liveItem(m,sp){
    const p=sp[m.handle];
    if(!p) return null; // product not published on this store — skip
    return {n:p.title||m.title,
            t:m.tagline||m.catalog_tagline||m.match_reason||'',
            p:p.price?fmt(p.price):'', img:p.img||'', handle:m.handle};
  }
  function renderLiveBatch(append){
    const gr=document.getElementById('resGrid');
    const batch=LIVE.matches.slice(LIVE.shown,LIVE.shown+LIVE_BATCH);
    return fetchProducts(batch.map(m=>m.handle)).then(sp=>{
      const missing=batch.filter(m=>!sp[m.handle]).map(m=>m.handle);
      if(missing.length) console.warn('[NT-AG] no /products/*.json for:',missing.join(', '));
      if(!append) gr.innerHTML='';
      const newItems=[];
      batch.forEach(m=>{const it=liveItem(m,sp); if(it){gr.appendChild(buildCard(it,true));newItems.push(it);}});
      LIVE.shown+=batch.length;
      const remaining=LIVE.matches.length-LIVE.shown;
      document.getElementById('resCount').textContent=LIVE.matches.length+' tales found';
      const sm=document.getElementById('showMore');
      if(remaining>0){sm.textContent=`Show ${Math.min(remaining,LIVE_BATCH)} more tales →`;sm.classList.add('show');}
      else sm.classList.remove('show');
      return newItems; /* resolved value — caller (doAsk) saves the tab */
    });
  }
  function saveTab(whom, items, ctxLabel){
    if(!items||!items.length) return;
    const lbl=(whom||'search').toLowerCase();
    const tid=Date.now();
    LIVE_TAB_ID=tid; CUR_TAB_ID=tid;
    const _ctx=ctxLabel||whom||'';
    /* drop any earlier tab with the same label, add this one at the front, cap at 8 */
    SEARCH_TABS=SEARCH_TABS.filter(t=>(t.label||'').toLowerCase()!==lbl);
    SEARCH_TABS.unshift({id:tid,label:whom||'search',ctxLabel:_ctx,items:items,quotes:_liveQuotes.slice()});
    SEARCH_TABS=SEARCH_TABS.slice(0,8);
    saveTabs();
    renderTabBar();
    showResultsState(_ctx);
    /* The drawer's MutationObserver may fire (microtask) with a stale _lastQ and
       overwrite ctxQ. Use setTimeout(0) to re-apply the correct label afterward. */
    if(_ctx){const ctxQ=document.getElementById('agCtxQ');setTimeout(function(){if(ctxQ)ctxQ.textContent=_ctx;},0);}
  }
  function renderTabBar(){
    const bar=document.getElementById('tabBar');
    if(!bar) return;
    if(!SEARCH_TABS.length){bar.classList.remove('show');return;}
    bar.classList.add('show'); bar.innerHTML='';
    /* newest tab on the left (SEARCH_TABS already newest-first) */
    SEARCH_TABS.forEach(tab=>{
      const b=document.createElement('button');
      b.className='stab'+(tab.id===CUR_TAB_ID?' on':'');
      b.textContent=(tab.label||'search')+' · '+tab.items.length;
      b.onclick=()=>restoreTab(tab.id);
      bar.appendChild(b);
    });
  }
  function restoreTab(id){
    const tab=SEARCH_TABS.find(t=>t.id===id);
    if(!tab) return;
    CUR_TAB_ID=id;
    const gr=document.getElementById('resGrid');
    gr.innerHTML='';
    tab.items.forEach(item=>gr.appendChild(buildCard(item,true)));
    document.getElementById('resHead').classList.add('show');
    document.getElementById('resLbl').textContent='tales for '+tab.label;
    document.getElementById('resCount').textContent=tab.items.length+' tales';
    document.getElementById('showMore').classList.remove('show');
    /* restore the AI quote lines saved with this pill (no API call → no wasted tokens) */
    document.getElementById('unlock').classList.add('show');
    renderQuotes(tab.label,(tab.quotes&&tab.quotes.length)?tab.quotes:genQuotes(tab.label));
    renderTabBar();
    /* populate the context bar with the full query saved when the tab was created */
    const ctxQ=document.getElementById('agCtxQ');
    const _rctx=tab.ctxLabel||tab.label;
    if(ctxQ) ctxQ.textContent=_rctx;
    /* setTimeout(0) wins over any MO microtask that might overwrite with stale _lastQ */
    setTimeout(function(){if(ctxQ)ctxQ.textContent=_rctx;},0);
    document.getElementById('agCtxBar').classList.add('show');
    document.getElementById('hd').classList.add('compact');
    document.getElementById('agLoadWrap').classList.remove('show');
    document.getElementById('resBody').style.display='block';
    document.getElementById('agTip').classList.add('show');
    document.getElementById('idleWrap').style.display='none';
    /* scroll results into view */
    const panel=document.getElementById('panel');
    if(panel) panel.scrollTo({top:0,behavior:'smooth'});
  }
  function showMoreTales(){
    if(LIVE.shown<LIVE.matches.length) renderLiveBatch(true);
    else flash('That’s every tale Gul found for this one.');
  }
  function showSearching(){
    const pre=(document.getElementById('sbPre')||{}).textContent||'';
    const val=(document.getElementById('inpF')||{}).value||'';
    const q=(pre+' '+val).trim()||val;
    showLoadingState(q);
  }

  /* ═══ AI QUOTES — live generation via GPT-4o (fallback: nt-haiku) ═══ */
  const NT_QUOTES_GPT='https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-gpt';
  const NT_QUOTES_HAIKU='https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-haiku';
  const QUOTE_SYS=`You create engravable lines for NukkadTales — handmade wooden pieces gifted in India. Each line gets carved in wood and displayed on a desk or shelf forever.

THE ONE RULE THAT GOVERNS EVERYTHING:
Give the actual thing — never a description of the thing.
A tattoo artist doesn't tattoo "I love roses" — they tattoo a rose.
- Query "funny" → lines that ARE funny ("Kal se pakka", "Social battery dead", "Meeting could've been an email"), NOT lines about being funny ("Hasi bhi aati hai")
- Query "Ghalib" → actual Ghalib lines ("Hazaaron khwahishen aisi"), NOT labels ("Ghalib ki nazar")
- Query "motivation" → lines that motivate ("Do the work", "Bas ek aur baar"), NOT labels about motivation
- Query "shayari" → actual poetic fragments in Hindi/Urdu, NOT descriptions like "Ishq ki kahani"
- Query "maa" → lines of love for a mother, NOT "Maa ki yaad"

EXCEPTION — ROOM / DECOR queries ("living room", "bedroom", "boho", "minimal", "office decor"):
These need ambient identity phrases — what the room would say if it could speak.
Good: "Gather here" · "Stay awhile" · "Come as you are" · "Be here now" · "Where stories live" · "Stay wild moon child" · "Free spirit" · "Good vibes only" · "Home is where" · "Breathe" · "Do deep work" · "Less is more"

CRAFT RULES:
- 2–4 words. Hard maximum 4 words. Fragment, never a full sentence. If a quote wants to be 5+ words, cut it or drop it.
- Complete thoughts only — "Dil-e-nadan" ✓, "Dil-e-nadan tujhe" ✗ (mid-thought cut)
- For poets (Ghalib, Gulzar, Faiz, Rumi, Kabir): use their actual famous lines
- For movies/songs: use actual famous dialogues or lyrics
- For relationships: warm giftable lines — something the recipient would be proud to display, not a WhatsApp caption or Instagram label
- For vibe/humor/self: deadpan wit, punchy self-aware lines worth owning

Return ONLY a raw JSON array of 24 strings. No markdown, no explanation.
["line one","line two",...]`;
  let _qreq=0;
  /* onDone(whom, quotes) — when provided, quotes are held and caller decides when to render */
  function fetchLiveQuotes(query,whom,onDone){
    const rid=++_qreq;
    document.getElementById('quoteMore').classList.remove('show');
    document.getElementById('unlockH').textContent='A few suggestions you may like';
    if(!onDone){
      document.getElementById('quoteGrid').innerHTML='<div class="nt-gulloader" style="--nt-gul-spr:url(\''+(window.NT_GUL_SPR13||'')+'\')"><span class="nt-gulload"></span><span>Gul is writing lines for you…</span></div>';
    }
    const _tryFetch=(url,body)=>fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(r=>r.json()).then(data=>{
        if(data.error)throw new Error(data.error.message||'API error');
        const raw=(data.content||[]).filter(b=>b.type==='text').map(b=>b.text).join('');
        const jm=raw.replace(/```json|```/g,'').trim().match(/\[[\s\S]*\]/);
        let qs=[]; if(jm){try{qs=JSON.parse(jm[0]).filter(x=>typeof x==='string'&&x.trim());}catch(e){}}
        if(!qs.length)throw new Error('no quotes');
        return qs;
      });
    // Try GPT-4o first, fall back to Haiku
    _tryFetch(NT_QUOTES_GPT,{system:QUOTE_SYS,messages:[{role:'user',content:'Query: "'+query+'"'}],max_tokens:900})
      .catch(()=>_tryFetch(NT_QUOTES_HAIKU,{model:'claude-haiku-4-5-20251001',max_tokens:900,system:QUOTE_SYS,messages:[{role:'user',content:'Query: "'+query+'"'}]}))
      .then(qs=>{
        if(rid!==_qreq)return;
        if(onDone){onDone(whom,qs);}else{renderQuotes(whom,qs);setLiveQuotes(qs);}
      })
      .catch(err=>{
        if(rid!==_qreq)return;
        console.warn('[NT-AG] live quotes failed, hiding section:',err&&err.message);
        // No fallback templates — hide rather than show irrelevant generic quotes
        document.getElementById('unlock').classList.remove('show');
        document.getElementById('quoteGrid').innerHTML='';
        if(onDone)onDone(whom,[]);
      });
  }
  function genQuotes(subject){
    const sub=(subject||'').trim(), cat=quoteCat(sub+' '+(document.getElementById('inpF').value||''));
    const Cap = sub ? sub.charAt(0).toUpperCase()+sub.slice(1) : 'You';
    return QTPL[cat].map(t=>t.replace(/\{C\}/g,Cap));
  }
  let _qpool=[], _qshown=0;
  /* the AI quotes for the search currently in progress — saved into its pill so a
     restored pill shows the same lines instead of regenerating (no wasted tokens) */
  let _liveQuotes=[];
  function setLiveQuotes(qs){
    _liveQuotes=(qs||[]).slice();
    if(LIVE_TAB_ID){const t=SEARCH_TABS.find(t=>t.id===LIVE_TAB_ID);if(t){t.quotes=_liveQuotes;saveTabs();}}
  }
  function addQuoteCard(qt, i){
    const grid = document.getElementById('quoteGrid');
    const d = document.createElement('div'); d.className='qcard';
    d.innerHTML=`<div class="q-tag">Made for you</div><div class="q-text">${qt}</div><div class="q-foot"><span class="q-price">From ₹1,299</span><button class="q-edit">Get this →</button></div>`;
    const heart = document.createElement('button');
    heart.className = 'heart' + (WISH.some(w=>w.n===qt&&w.isQuote)?' on':'');
    heart.innerHTML='♥'; heart.dataset.q = qt;
    heart.onclick = (e)=>{ e.stopPropagation(); toggleQuoteWish(qt, heart); };
    d.appendChild(heart);
    d.querySelector('.q-edit').onclick=(e)=>{e.stopPropagation();openEditor(qt);};
    d.onclick = ()=>openEditor(qt);
    grid.appendChild(d);
    setTimeout(()=>requestAnimationFrame(()=>d.classList.add('in')), 40+(i||0)*45);
  }
  function filterStockQuotes(quotes){
    const stockTitles=Array.from(document.querySelectorAll('#resGrid .rc-n'))
      .map(function(el){return el.textContent.trim().toLowerCase();});
    if(!stockTitles.length) return quotes;
    return (quotes||[]).filter(function(q){
      const ql=q.trim().toLowerCase();
      return !stockTitles.some(function(t){return t===ql||t.includes(ql)||ql.includes(t);});
    });
  }
  function renderQuotes(subject, quotes){
    const filtered=filterStockQuotes(quotes);
    if(!filtered||!filtered.length){ document.getElementById('unlock').classList.remove('show'); return; }
    _qpool=filtered;
    document.getElementById('unlockH').textContent='A few suggestions you may like';
    const grid=document.getElementById('quoteGrid'); grid.innerHTML='';
    _qpool.slice(0,4).forEach(addQuoteCard); _qshown=Math.min(4,_qpool.length);
    const sm=document.getElementById('quoteMore');
    if(_qpool.length>_qshown){sm.textContent=`Show ${Math.min(_qpool.length-_qshown,4)} more lines →`;sm.classList.add('show');}
    else sm.classList.remove('show');
    /* nudge — rendered once on first load, sits below the grid (not inside it) */
    const unlockEl=document.getElementById('unlock');
    if(unlockEl&&!unlockEl.querySelector('.q-nudge')){
      const nudge=document.createElement('div'); nudge.className='q-nudge';
      nudge.innerHTML='<span>Know exactly what you want?</span><button onclick="window.openEditor(\'\')">Type it — we\'ll carve it →</button>';
      unlockEl.appendChild(nudge);
    }
  }
  function showMoreQuotes(){
    const next=_qpool.slice(_qshown,_qshown+4);
    next.forEach((qt,i)=>addQuoteCard(qt,i));
    _qshown+=next.length;
    const sm=document.getElementById('quoteMore');
    const rem=_qpool.length-_qshown;
    if(rem>0){sm.textContent=`Show ${Math.min(rem,4)} more lines →`;sm.classList.add('show');}
    else sm.classList.remove('show');
    /* after 2nd show-more (12 shown), add a "change search" hint near the nudge */
    const nudge=document.querySelector('#unlock .q-nudge');
    if(_qshown>=12&&nudge&&!nudge.querySelector('.q-nudge-change')){
      const hint=document.createElement('span'); hint.className='q-nudge-change';
      hint.innerHTML=' · <button onclick="window.focusSearch()">Change your search</button> for different results';
      nudge.querySelector('span').after(hint);
    }
  }

  /* Open the personalisation editor — the customise slider. The drawer is
     rendered inline on the home page, so check this window first; the
     parent fallback covers the standalone /?view=ask-gul route if it is
     ever framed. */
  function sliderHost(){
    if(window.ntOpenSlider) return window;
    try{
      if(window.parent && window.parent !== window && window.parent.ntOpenSlider) return window.parent;
    }catch(e){}
    return null;
  }
  function openEditor(q){
    window._trackGulEvent('tale_click', q||'');
    const W = sliderHost();
    if(W){
      if(q) try{ W.sessionStorage.setItem('nt_landing_text', q); }catch(e){}
      try{ W.sessionStorage.setItem('nt_skip_welcome','1'); }catch(e){}
      /* always flag origin so slider shows back bar; always close overlay so
         chip editor isn't hidden behind the Ask Gul drawer */
      try{ W.sessionStorage.setItem('nt_ask_gul_origin','1'); }catch(e){}
      try{ W.sessionStorage.setItem('nt_from_ask_gul','1'); }catch(e){}
      if(W.closeAg) W.closeAg();
      W.ntOpenSlider('customise');
      return;
    }
    flash('Opening editor — “'+q+'”. Tweak the words, then add a name or message.');
  }
  /* reopen Ask Gul overlay and restore last search results — called from slider back bar */
  function _agReopen(){
    const ov=document.getElementById('agOverlay'); if(ov) ov.classList.add('open');
    document.body.classList.add('ag-open');
    const sh=document.querySelector('.ag-sheet'); if(sh) sh.classList.add('open');
    if(CUR_TAB_ID) setTimeout(()=>restoreTab(CUR_TAB_ID),60);
  }
  function goTop(){ document.getElementById('panel').scrollTo({top:0,behavior:'smooth'}); }
  function goAddName(){
    const W = sliderHost();
    if(W){
      try{ W.sessionStorage.setItem('nt_skip_welcome','1'); }catch(e){}
      if(W.closeAg) W.closeAg();
      W.ntOpenSlider('customise');
      return;
    }
    flash('Opening the personalisation studio — add a name, date or message.');
  }

  /* ═══ RESULTS ═══ */
  function buildCard(r, reveal){
    const d=document.createElement('div'); d.className='rcard';
    const imgHtml=r.img?`<img src="${r.img}" alt="" loading="lazy">`:'';
    d.innerHTML=`<div class="rc-img">${imgHtml}</div><div class="rc-b"><div class="rc-n">${r.n}</div><div class="rc-t">${r.t||''}</div><div class="rc-foot"><span class="rc-p">${r.p||''}</span><button class="rc-add">＋ Bag</button></div></div>`;
    const heart=document.createElement('button');
    heart.className='heart'+(WISH.some(w=>w.n===r.n&&!w.isQuote)?' on':'');
    heart.dataset.n=r.n; heart.innerHTML='♥';
    heart.onclick=(e)=>toggleWish(r,heart,e);
    d.appendChild(heart);
    const item={kind:'ready',n:r.n,t:r.t||'',price:priceNum(r.p),handle:r.handle||'',img:r.img||''};
    d.querySelector('.rc-add').onclick=(e)=>{e.stopPropagation();openVariant(item);};
    d.onclick=()=>openVariant(item);
    if(reveal) requestAnimationFrame(()=>requestAnimationFrame(()=>d.classList.add('in'))); else d.classList.add('in');
    return d;
  }
  function refreshHearts(){
    document.querySelectorAll('.heart[data-n]').forEach(h=>h.classList.toggle('on',WISH.some(w=>w.n===h.dataset.n&&!w.isQuote)));
    document.querySelectorAll('.heart[data-q]').forEach(h=>h.classList.toggle('on',WISH.some(w=>w.n===h.dataset.q&&w.isQuote)));
  }
  function totalFor(whom,lbl){return moreCount(whom||lbl)+4;}
  function renderResults(items,lbl,whom,quotes,total){
    document.getElementById('resLbl').textContent=lbl||'tales for you';
    document.getElementById('resHead').classList.add('show');
    document.getElementById('resCount').textContent=`${total} tales · showing 4`;
    document.getElementById('showMore').textContent=`Show ${total-4} more tales →`;
    document.getElementById('showMore').classList.add('show');
    document.getElementById('unlock').classList.add('show');
    const gr=document.getElementById('resGrid'); gr.innerHTML='';
    (items||[]).slice(0,4).forEach(r=>gr.appendChild(buildCard(r,true)));
    renderQuotes(whom,quotes);
    document.getElementById('panel').scrollTo({top:0,behavior:'smooth'});
  }
  function showResults(items,lbl,whom){
    const quotes=genQuotes(whom), total=totalFor(whom,lbl);
    renderResults(items,lbl,whom,quotes,total);
    const q=(document.getElementById('inpF').value||whom||'').trim()||whom||'search';
    pushHist({q,label:lbl,whom,items:(items||[]).slice(0,4),quotes,total,pre:document.getElementById('sbPre').textContent||''});
  }

  /* ═══ HINT LINE + CONTEXT PILLS ═══ */
  function setHint(key){
    const h = HINTS[key] || HINTS.default;
    document.getElementById('hintLine').innerHTML =
      `<span class="spark">✨</span><span class="htxt">${h.text} <span class="eg">${h.eg}</span></span>`;
  }
  function renderPills(list){ /* ctx pills removed — chips built by inline buildChips() in drawer */ }

  /* ═══ INTENT ═══ */
  function intentTap(id){
    ['gift','decor','self'].forEach(k=>document.getElementById('ic-'+k).classList.toggle('on',k===id));
    document.getElementById('hdHeading').textContent=({gift:"Who's the gift for?",decor:"Which space are we styling?",self:"What's the vibe today?"})[id]||'What are you looking for?';
    const d=INTENT_DATA[id];
    if(!d) return;
    const pre=document.getElementById('sbPre'); pre.textContent=d.prefix; pre.classList.add('show');
    document.getElementById('inpF').placeholder='type a name, room or vibe…';
    setHint(id);
  }

  /* Fetch real products from a Shopify collection — returns Promise<item[]> so caller can saveTab */
  function fetchCollection(handle, label, whom){
    document.getElementById('resHead').classList.add('show');
    document.getElementById('resLbl').textContent=label||('browse · '+handle.replace(/-/g,' '));
    document.getElementById('resCount').textContent='';
    document.getElementById('showMore').classList.remove('show');
    const gr=document.getElementById('resGrid'); gr.innerHTML='';
    for(let i=0;i<4;i++){const sk=document.createElement('div');sk.className='rcard rc-skel in';gr.appendChild(sk);}
    return fetch('/collections/'+handle+'/products.json?limit=8')
      .then(r=>r.json())
      .then(d=>{
        gr.innerHTML='';
        const prods=d.products||[];
        if(!prods.length){
          gr.innerHTML='<div style="padding:20px;text-align:center;color:var(--muted);font-size:13px">No tales found here. <a href="/collections/all" style="color:var(--accent-d)">Browse all tales →</a></div>';
          return [];
        }
        document.getElementById('resCount').textContent=prods.length+' tales';
        const collItems=[];
        prods.forEach(p=>{
          const price=p.variants&&p.variants[0]?Math.round(parseFloat(p.variants[0].price)):0;
          const it={n:p.title,t:(p.body_html||'').replace(/<[^>]+>/g,'').slice(0,80),
                    p:fmt(price),handle:p.handle,img:p.images&&p.images[0]?p.images[0].src:''};
          collItems.push(it);
          gr.appendChild(buildCard(it,true));
        });
        /* Pre-warm PRODCACHE so variant picker opens instantly with no loading delay */
        fetchProducts(prods.map(p=>p.handle));
        try{pushHist({q:handle,label,whom:whom||'',items:prods.slice(0,4).map(p=>({n:p.title}))});}catch(e){}
        return collItems;
      })
      .catch(()=>{
        gr.innerHTML='<div style="padding:20px;text-align:center;color:var(--muted);font-size:13px"><a href="/collections/all" style="color:var(--accent-d)">Browse all tales →</a></div>';
        return [];
      });
  }

  /* ═══ ASK — live search, collection fallback on fail or zero results ═══ */
  let _prodDone = false, _qPending = null;

  function doAsk(){
    const val=document.getElementById('inpF').value.trim();
    if(!val){flash('Type a name, a room, or a feeling — then tap Ask Gul.');focusSearch();return;}
    gulReact();
    LIVE_TAB_ID=null; CUR_TAB_ID=null; _liveQuotes=[]; renderTabBar();
    const pre=(document.getElementById('sbPre').textContent||'').trim();
    const query=(pre?pre+' ':'')+val;
    window._trackGulEvent('feed', query);
    const whom=extractWhom(val);
    const lbl=buildLabel(val, whom);
    document.getElementById('inpF').blur();
    showSearching();
    _prodDone = false; _qPending = null;

    /* AI quotes — held until products render so both appear at the same time */
    fetchLiveQuotes(query, whom, function(w, qs){
      setLiveQuotes(qs);
      if(_prodDone){
        renderQuotes(w, qs);
        document.getElementById('unlock').classList.add('show');
      } else {
        _qPending = {w, qs};
      }
    });

    function _quoteSkelHtml(){
      return [0,1,2,3].map(()=>
        '<div class="qcard-skel">'+
        '<div class="ag-skel qs-tag"></div>'+
        '<div class="ag-skel qs-line1"></div>'+
        '<div class="ag-skel qs-line2"></div>'+
        '<div class="qs-foot">'+
        '<div class="ag-skel qs-price"></div>'+
        '<div class="ag-skel qs-btn"></div>'+
        '</div></div>').join('');
    }

    /* called after products are displayed — shows quote skeletons immediately,
       replaced by real quotes when the AI response arrives */
    function _flushQuotes(){
      _prodDone = true;
      if(_qPending){
        renderQuotes(_qPending.w, _qPending.qs);
        document.getElementById('unlock').classList.add('show');
        _qPending = null;
      } else {
        document.getElementById('unlock').classList.add('show');
        document.getElementById('quoteGrid').innerHTML=_quoteSkelHtml();
      }
    }

    searchAPI(query)
      .then(matches=>{
        LIVE={matches,shown:0,whom};
        if(!matches.length){
          return fetchCollection(matchCollection(val)||DEFAULT_COLLECTION,lbl,whom)
            .then(items=>{saveTab(whom,items,query);_flushQuotes();});
        }
        document.getElementById('resLbl').textContent=lbl;
        return renderLiveBatch(false).then(items=>{
          if(!items.length){
            return fetchCollection(matchCollection(val)||DEFAULT_COLLECTION,lbl,whom)
              .then(items2=>{saveTab(whom,items2,query);_flushQuotes();});
          }
          saveTab(whom,items,query);
          try{pushHist({q:val,label:lbl,whom,live:1,pre});}catch(e){}
          _flushQuotes();
        });
      })
      .catch(err=>{
        console.warn('[NT-AG] live search failed → collection fallback:',err&&err.message);
        LIVE={matches:[],shown:0,whom:''};
        fetchCollection(matchCollection(val)||DEFAULT_COLLECTION,lbl,whom)
          .then(items=>{saveTab(whom,items,query);_flushQuotes();});
      });
  }

  /* ═══ TOAST ═══ */
  let toastT;
  function flash(msg){
    const el=document.getElementById('toast'); if(!el) return;
    el.textContent=msg; el.classList.add('show');
    clearTimeout(toastT); toastT=setTimeout(()=>el.classList.remove('show'),2200);
  }
  function focusSearch(){
    document.getElementById('panel').scrollTo({top:0,behavior:'smooth'});
    const i=document.getElementById('inpF'); i.focus(); i.select&&i.select();
  }

  /* ═══ WISHLIST ═══ */
  let WISH=[];
  try{WISH=JSON.parse(localStorage.getItem('nt_wish')||'[]')||[];}catch(e){WISH=[];}
  function saveWish(){try{localStorage.setItem('nt_wish',JSON.stringify(WISH));}catch(e){}}
  function updWish(){
    const n=WISH.length;
    const el=document.getElementById('wishN'); if(el) el.textContent=n;
    const b=document.getElementById('saveBtn'); if(b) b.classList.toggle('has',n>0);
  }
  function toggleWish(r,btn,ev){
    if(ev) ev.stopPropagation();
    const i=WISH.findIndex(w=>w.n===r.n&&!w.isQuote);
    if(i>=0){WISH.splice(i,1);flash(`Removed "${r.n}"`);}
    else{WISH.push({n:r.n,t:r.t,p:r.p,img:r.img||'',handle:r.handle||'',isQuote:false});flash(`Saved "${r.n}" ♥`);}
    saveWish(); updWish(); refreshHearts();
  }
  function toggleQuoteWish(qt, btn){
    const i=WISH.findIndex(w=>w.n===qt&&w.isQuote);
    if(i>=0){WISH.splice(i,1);flash('Removed from saved');}
    else{WISH.push({n:qt,t:'AI Quote',p:'₹1,299',isQuote:true});flash('Quote saved ♥');}
    saveWish(); updWish(); refreshHearts();
  }
  function openSaved(){
    const grid=document.getElementById('sheetGrid'); grid.innerHTML='';
    if(!WISH.length){grid.innerHTML='<div class="sheet-empty">No saved tales yet.<br>Tap the ♥ on any tale or quote — your shortlist stays on this device.</div>';}
    else WISH.forEach(r=>grid.appendChild(r.isQuote?buildSavedQuote(r):buildSheetCard(r)));
    document.getElementById('sheet').classList.add('open');
  }
  function closeSheet(){document.getElementById('sheet').classList.remove('open');}
  function buildSheetCard(r){
    const d=document.createElement('div'); d.className='rcard in';
    const imgHtml=r.img?`<img src="${r.img}" alt="" loading="lazy">`:'';
    d.innerHTML=`<div class="rc-img">${imgHtml}</div><div class="rc-b"><div class="rc-n">${r.n}</div><div class="rc-t">${r.t||''}</div><div class="rc-foot"><span class="rc-p">${r.p||''}</span><button class="rc-add">＋ Bag</button></div></div>`;
    const heart=document.createElement('button'); heart.className='heart on'; heart.dataset.n=r.n; heart.innerHTML='♥';
    heart.onclick=(e)=>{e.stopPropagation();toggleWish(r,heart,e);openSaved();};
    d.appendChild(heart);
    const item={kind:'ready',n:r.n,t:r.t||'',price:priceNum(r.p||'₹999'),handle:r.handle||'',img:r.img||''};
    d.querySelector('.rc-add').onclick=(e)=>{e.stopPropagation();closeSheet();openVariant(item);};
    d.onclick=()=>{closeSheet();openVariant(item);};
    return d;
  }
  function buildSavedQuote(r){
    const d=document.createElement('div'); d.className='qsave-card';
    d.innerHTML=`<div class="qsave-label">AI Quote</div><div class="qsave-text">${r.n}</div><div class="qsave-foot"><span class="qsave-price">From ₹1,299</span><button class="q-edit">Get this →</button></div>`;
    const heart=document.createElement('button'); heart.className='heart on'; heart.dataset.q=r.n; heart.innerHTML='♥';
    heart.onclick=(e)=>{e.stopPropagation();toggleQuoteWish(r.n,heart);openSaved();};
    d.appendChild(heart);
    d.querySelector('.q-edit').onclick=(e)=>{e.stopPropagation();closeSheet();openEditor(r.n);};
    d.onclick=()=>{closeSheet();openEditor(r.n);};
    return d;
  }

  /* ═══ FINISHES + BAG (variant picker → bag → cart) ═══ */
  const FINISHES=[
    {name:'Natural Oak', hex:'#b8895a', txt:'#3a2b1d'},
    {name:'Warm Teak',   hex:'#7c4b1e', txt:'#fdf6ec'},
    {name:'Walnut',      hex:'#4a2c0a', txt:'#f6ede1'},
    {name:'Espresso',    hex:'#5d4037', txt:'#f6ede1'},
    {name:'Ivory',       hex:'#f5f0e8', txt:'#3a2b1d'},
    {name:'Sage',        hex:'#558b2f', txt:'#fdf6ec'},
    {name:'Terracotta',  hex:'#bf5530', txt:'#fff4ec'},
    {name:'Charcoal',    hex:'#3a3a3a', txt:'#f6ede1'}
  ];
  function priceNum(p){return parseInt(String(p==null?'':p).replace(/[^\d]/g,''))||0;}
  function fmt(n){return '₹'+Number(n||0).toLocaleString('en-IN');}

  let BAG=[];
  try{BAG=JSON.parse(localStorage.getItem('nt_bag')||'[]')||[];}catch(e){BAG=[];}
  function saveBag(){try{localStorage.setItem('nt_bag',JSON.stringify(BAG));}catch(e){}}
  function bagCount(){return BAG.reduce((s,b)=>s+b.qty,0);}
  function bagTotal(){return BAG.reduce((s,b)=>s+b.qty*b.price,0);}
  function updBag(){
    const n=bagCount();
    const nEl=document.getElementById('bagN'); if(nEl) nEl.textContent=n;
    const tEl=document.getElementById('bagTot2'); if(tEl) tEl.textContent=fmt(bagTotal());
    const bagB=document.getElementById('bagBtn');
    if(bagB){ bagB.classList.toggle('has', n>0); }
  }

  /* ---- variant picker ---- */
  let _vItem=null, _vFinish=0, _vQty=1, _vList=null;
  /* colour words loaded from nt-colors.js (window.NT_COLOR_MAP) — single source of truth */
  const COLOR_WORDS = window.NT_COLOR_MAP || {};
  function lightText(color){
    const m=color&&color.match(/rgb\(\s*(\d+),\s*(\d+),\s*(\d+)/i);
    if(m) return (parseInt(m[1])*.299+parseInt(m[2])*.587+parseInt(m[3])*.114)<150;
    if(color&&color[0]==='#'){const n=parseInt(color.slice(1),16);return((n>>16&255)*.299+(n>>8&255)*.587+(n&255)*.114)<150;}
    return false;
  }
  function finishLook(name,i){
    const n=(name||'').toLowerCase();
    const pal=FINISHES.find(f=>f.name.toLowerCase()===n||n.includes(f.name.toLowerCase().split(' ').pop()));
    if(pal) return {hex:pal.hex,txt:pal.txt};
    for(const w in COLOR_WORDS) if(n.includes(w)){const hx=COLOR_WORDS[w];return {hex:hx,txt:lightText(hx)?'#f6ede1':'#3a2b1d'};}
    const fb=FINISHES[i%FINISHES.length]; return {hex:fb.hex,txt:fb.txt};
  }
  /* Read data-color from rendered product cards — matches admin-configured swatch colors exactly */
  function getCardSwatchMap(handle){
    const map={};
    if(!handle) return map;
    document.querySelectorAll('a.pcard[href*="/'+handle+'"]').forEach(card=>{
      card.querySelectorAll('.pswatch[title],.pswatch-data[title]').forEach(s=>{
        const c=s.getAttribute('data-color'),t=s.getAttribute('title');
        if(c&&t) map[t]=c;
      });
    });
    return map;
  }
  /* Parse "(+Rs. 300)" or "(+₹300)" from an option value name → returns 300, else 0 */
  function parsePremium(name){
    const m=(name||'').match(/\(\+(?:Rs\.?\s*|₹\s*)(\d+)\)/i);
    return m?parseInt(m[1],10):0;
  }
  function buildVList(){
    const cardColors=getCardSwatchMap(_vItem&&_vItem.handle);
    const c=_vItem&&_vItem.handle?PRODCACHE[_vItem.handle]:null;
    if(c&&c.variants&&c.variants.length){
      /* find which option index is the colour/finish option */
      const opts=c.options||[];
      const colorIdx=opts.findIndex(o=>{const n=(o||'').toLowerCase();return n.includes('color')||n.includes('colour')||n.includes('finish')||n.includes('shade')||n.includes('wood')||n.includes('material')||n.includes('texture');});
      /* base price = cheapest real variant price (for premium inference below) */
      const realPrices=c.variants.filter(v=>v.price>0).map(v=>v.price);
      const baseP=realPrices.length?Math.min(...realPrices):(_vItem?_vItem.price:0);
      /* deduplicate by colour value — for Color+Size products show one swatch per colour */
      const seen=new Set(), rows=[];
      c.variants.forEach((v,i)=>{
        const colorVal=colorIdx>=0?(v['option'+(colorIdx+1)]||v.option1||v.title):v.title;
        if(!seen.has(colorVal)){
          seen.add(colorVal);
          /* Priority: 1) admin swatch via ?view=nt-swatches  2) card DOM  3) NT_COLOR_MAP */
          const swatchColor=(c.swatches&&c.swatches[colorVal]);
          const color=swatchColor||cardColors[colorVal]||cardColors[v.title];
          const lk=color?{hex:color,txt:lightText(color)?'#f6ede1':'#3a2b1d'}:finishLook(colorVal,i);
          /* Price: use real Shopify variant price when it exceeds base; otherwise infer from
             "(+Rs. X)" in the option value name — handles Scripts-based or un-updated pricing */
          const varP=(v.price>0&&v.price>baseP)?v.price:(baseP+parsePremium(colorVal));
          rows.push({name:colorVal==='Default Title'?'Standard':colorVal,hex:lk.hex,txt:lk.txt,variantId:v.id,price:varP||_vItem.price});
        }
      });
      return rows;
    }
    return FINISHES.map(f=>({name:f.name,hex:f.hex,txt:f.txt,variantId:0,price:_vItem?_vItem.price:0}));
  }
  function _varAddBtn(){return document.querySelector('#variantSheet .var-add');}
  function openVariant(item){
    _vItem=item; _vFinish=0; _vQty=1;
    document.querySelector('#variantSheet .modal-card').classList.remove('done');
    if(item.handle && !PRODCACHE[item.handle]){
      /* Variants not cached yet — open sheet with basics, render swatches only after fetch
         so the user never sees a flash of placeholder/wrong colours */
      _vList=FINISHES.map(f=>({name:f.name,hex:f.hex,txt:f.txt,variantId:0,price:item.price}));
      const prev=document.getElementById('varPrev');
      if(item.img){prev.style.background=`center/cover no-repeat url('${item.img}')`;prev.querySelector('span').textContent='';}
      else{prev.style.background='';prev.querySelector('span').textContent=item.n;}
      document.getElementById('varName').textContent=item.n;
      document.getElementById('varSub').textContent=item.kind==='quote'?'Custom tale · by Nukkad AI':(item.t||'Ready-to-ship tale');
      document.getElementById('varPrice').textContent=fmt(item.price);
      document.getElementById('varQty').textContent=_vQty;
      document.getElementById('varFinishName').textContent='';
      const sw=document.getElementById('varSwatches');
      if(sw) sw.innerHTML='<div class="nt-gulloader" style="--nt-gul-spr:url(\''+(window.NT_GUL_SPR13||'')+'\')"><span class="nt-gulload"></span><span>finding the finishes…</span></div>';
      const btn=_varAddBtn(); if(btn){btn.disabled=true;btn.textContent='Loading…';}
      document.getElementById('variantSheet').classList.add('open');
      fetchProducts([item.handle]).then(()=>{
        if(_vItem===item){_vList=buildVList();_vFinish=0;renderVariant();}
        const b=_varAddBtn(); if(b){b.disabled=false;b.textContent='Add to bag';}
      });
    } else {
      _vList=buildVList();
      renderVariant();
      document.getElementById('variantSheet').classList.add('open');
    }
  }
  function closeVariant(){document.getElementById('variantSheet').classList.remove('open');}
  function openPolicy(){ flash('Shipping & returns: painted on order · delivery in 7–10 days · handcrafted in engineered wood.'); }
  function variantUnitPrice(){ const v=_vList&&_vList[_vFinish]; return (v&&v.price)||_vItem.price; }
  function renderVarPrice(){
    document.getElementById('varPrice').textContent=fmt(variantUnitPrice());
  }
  function renderVariant(){
    const f=_vList[_vFinish];
    const isQuote=_vItem.kind==='quote';
    const prev=document.getElementById('varPrev');
    if(_vItem.img){
      prev.style.background=`center/cover no-repeat url('${_vItem.img}')`;
      prev.querySelector('span').textContent='';
    } else {
      prev.style.background=f.hex; prev.style.color=f.txt;
      prev.querySelector('span').textContent=_vItem.n;
    }
    document.getElementById('varName').textContent=_vItem.n;
    document.getElementById('varSub').textContent=isQuote?'Custom tale · by Nukkad AI':(_vItem.t||'Ready-to-ship tale');
    document.getElementById('varFinishName').textContent=f.name;
    document.getElementById('varQty').textContent=_vQty;
    renderVarPrice();
    const sw=document.getElementById('varSwatches'); sw.innerHTML='';
    _vList.forEach((ff,i)=>{
      const s=document.createElement('button'); s.className='swatch'+(i===_vFinish?' on':'');
      s.style.background=ff.hex; s.title=ff.name;
      s.onclick=()=>{_vFinish=i;renderVariant();};
      sw.appendChild(s);
    });
  }
  function varQty(d){_vQty=Math.max(1,Math.min(9,_vQty+d));document.getElementById('varQty').textContent=_vQty;renderVarPrice();}
  function confirmBag(){
    const f=_vList[_vFinish];
    const unit = variantUnitPrice();
    const key=_vItem.kind+'|'+_vItem.n+'|'+f.name;
    const ex=BAG.find(b=>b.key===key);
    if(ex) ex.qty=Math.min(9,ex.qty+_vQty);
    else BAG.push({key,kind:_vItem.kind,n:_vItem.n,t:_vItem.t||'',price:unit,finish:f.name,hex:f.hex,txt:f.txt,
                   qty:_vQty,custom:false,pers:'',variantId:f.variantId||0,handle:_vItem.handle||'',img:_vItem.img||''});
    saveBag(); updBag();
    /* in-modal confirmation with a clear next step */
    document.getElementById('vdSub').textContent=`${_vItem.n} · ${f.name}`;
    const n=bagCount();
    document.getElementById('vdCount').textContent=`Your bag now has ${n} ${n===1?'tale':'tales'} · ${fmt(bagTotal())}`;
    document.querySelector('#variantSheet .modal-card').classList.add('done');
  }

  /* ---- bag ---- */
  function openBag(){renderBag();document.getElementById('bagSheet').classList.add('open');}
  function closeBag(){document.getElementById('bagSheet').classList.remove('open');}
  function renderBag(){
    const list=document.getElementById('bagList'); list.innerHTML='';
    if(!BAG.length){
      list.innerHTML='<div class="bag-empty">Your bag is empty.<br>Tap “＋ Bag” on any tale — or “Customise” on a quote — pick a finish, then send it all to cart together.</div>';
      document.getElementById('bagFoot').style.display='none'; return;
    }
    document.getElementById('bagFoot').style.display='block';
    BAG.forEach((b,idx)=>{
      const it=document.createElement('div'); it.className='bitem';
      const thumb=b.img?`<div class="bthumb" style="background:center/cover no-repeat url('${b.img}')"></div>`
                       :`<div class="bthumb" style="background:${b.hex};color:${b.txt}"><span>${b.n}</span></div>`;
      it.innerHTML=thumb+
        `<div class="binfo"><div class="bname">${b.n}</div>`+
        `<div class="bfin"><span class="dot" style="background:${b.hex}"></span>${b.finish}${b.custom?' · Personalised':(b.kind==='quote'?' · Custom':'')}</div>`+
        (b.pers?`<div class="bpers">✎ “${b.pers}”</div>`:'')+
        `<div class="bqty"><button class="mini" data-d="-1">–</button><span class="n">${b.qty}</span><button class="mini" data-d="1">＋</button><span class="bprice">${fmt(b.price*b.qty)}</span></div></div>`+
        `<button class="bremove" title="Remove">×</button>`;
      it.querySelectorAll('.mini').forEach(btn=>btn.onclick=()=>bagQty(idx,parseInt(btn.dataset.d)));
      it.querySelector('.bremove').onclick=()=>bagRemove(idx);
      list.appendChild(it);
    });
    document.getElementById('bagTotal').textContent=fmt(bagTotal());
  }
  function bagQty(idx,d){
    if(!BAG[idx])return;
    BAG[idx].qty=Math.max(1,Math.min(9,BAG[idx].qty+d));
    saveBag(); updBag(); renderBag();
  }
  function bagRemove(idx){
    BAG.splice(idx,1); saveBag(); updBag(); renderBag();
  }
  function proceedCart(){
    if(!BAG.length){flash('Your bag is empty.');return;}
    const real=BAG.filter(b=>b.variantId), custom=BAG.filter(b=>!b.variantId);
    if(!real.length){
      flash('These are custom tales — tap one to finish it in the studio first.');
      return;
    }
    const btn=document.querySelector('#bagSheet .bag-cta');
    if(btn){btn.disabled=true;btn.textContent='Adding to cart…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:real.map(b=>({id:b.variantId,quantity:b.qty}))})})
      .then(r=>{
        if(!r.ok) return r.json().then(j=>{throw new Error(j.description||j.message||('HTTP '+r.status));});
        return r.json();
      })
      .then(()=>{
        BAG=custom; saveBag(); updBag();
        closeBag();
        /* Open Shopflo cart drawer — same call used by main page QV */
        const host=(typeof handleFloCartBtn==='function')?window:
                   (window.parent&&window.parent!==window&&typeof window.parent.handleFloCartBtn==='function')?window.parent:null;
        if(host) host.handleFloCartBtn();
        else window.location.href='/cart';
      })
      .catch(err=>{
        console.warn('[NT-AG] cart add failed:',err&&err.message);
        if(btn){btn.disabled=false;btn.textContent='Proceed to cart →';}
        flash('Couldn’t add to cart — '+((err&&err.message)||'please try again.'));
      });
  }

  /* ═══ HISTORY ═══ */
  let HIST=[];
  try{HIST=JSON.parse(localStorage.getItem('nt_hist')||'[]')||[];}catch(e){HIST=[];}
  function saveHist(){try{localStorage.setItem('nt_hist',JSON.stringify(HIST.slice(0,8)));}catch(e){}}
  function pushHist(entry){HIST=HIST.filter(h=>h.q!==entry.q);HIST.unshift(entry);HIST=HIST.slice(0,8);saveHist();renderHist();}
  function renderHist(){
    const wrap=document.getElementById('histWrap');
    const row=document.getElementById('histRow');
    if(!wrap||!row) return;
    if(!HIST.length){wrap.style.display='none';return;}
    wrap.style.display='';
    row.innerHTML='';
    HIST.forEach(entry=>{
      const b=document.createElement('div'); b.className='hpill';
      const label=(entry.whom||entry.q||'search');
      const n=entry.total||(entry.items&&entry.items.length)||'';
      b.innerHTML=label+(n?`<span class="hn">${n}</span>`:'');
      b.onclick=()=>{
        const tab=SEARCH_TABS.find(t=>(t.label||'').toLowerCase()===label.toLowerCase());
        if(tab){ restoreTab(tab.id); }
        else{
          document.getElementById('inpF').value=entry.q||label;
          if(entry.pre) document.getElementById('sbPre').textContent=entry.pre;
          doAsk();
        }
      };
      row.appendChild(b);
    });
  }
  function restoreHist(h){
    document.getElementById('inpF').value=h.q;
    const pre=document.getElementById('sbPre');
    if(h.pre){pre.textContent=h.pre;pre.classList.add('show');}
    if(h.live){doAsk();return;} /* live searches re-run — server caches them */
    renderResults(h.items,h.label,h.whom,h.quotes,h.total||h.count||((h.items||[]).length));
  }

  /* ═══ COLD STATE CHIPS + GHOST TALES (also built here in case Foxify blocks the inline snippet script) ═══ */
  const _MODE_CHIPS={
    gift: ['For Maa','New home','Retirement','Best friend','First salary','Tough year','Something funny','Boss\'s last day'],
    decor:['Living room','Home office','Bedroom','New workspace','Study corner','Kids\' room','Above the sofa','Reception area'],
    self: ['My story','Daily reminder','Something motivating','Night owl','New chapter','My name','Coder at 3am','Just for today']
  };
  const _GHOST_TALES={
    gift:['Papa retiring this month','Maa who does everything','Best friend\'s first flat',
      'Partner, our anniversary','Boss\'s last day','Teacher who changed things',
      'Sister turning 30','Brother\'s first salary','New dad on the block',
      'Dadi\'s golden years','Friend through a tough year','The quiet mentor',
      'CA in busy season','Coder at 3am','Pilot who travels a lot',
      'Running a startup','Going abroad soon','The eldest daughter',
      'Empty nesters finally','Youngest sibling','Something funny, no drama',
      'Big promotion deserved','Found herself this year','Just got married',
      'New chapter, fresh start','20 years together','Just graduated',
      'Moving cities together','Far from home but okay','A quiet thank you'],
    decor:['Living room, warm vibes','Home office, focus energy','Bedroom, slow mornings',
      'Pooja corner, serene','Entryway, first impression','Study room, flow state',
      'Kitchen, heart of the home','Kids\' room, dream big','Above the sofa',
      'Reading nook, quiet corner','My desk setup','New flat, fresh start',
      'Reception area, calm','Startup office wall','Master bedroom corner',
      'Guest room, good vibes','Balcony nook','Mandir corner',
      'Work from home setup','Art wall vibes','Above the bed',
      'Nursery, soft & warm','Coffee corner','Dining area',
      'Hallway, say hello','Office cabin wall','Creative studio'],
    self:['Calm & grateful','Night owl by nature','New chapter, new me',
      'My morning mantra','Introvert energy','Chai & quiet moments',
      'Small joys, daily','Hustle & heart','Dreamer with a plan',
      'The overthinker','Made it this far','Coder at 3am',
      'Startup grind life','Moving cities alone','Starting over is brave',
      'Just breathe','My name, my story','Plant parent vibes',
      'Running on chai','Maa\'s favourite','First salary milestone',
      'Desk with good energy','Far from home but fine','The soft life',
      'Born stubborn','Sahab energy','Too much on my mind',
      'The quiet one','Grateful for today','Earned every bit']
  };
  const _GHOST_LBL={gift:'or search for someone like…',decor:'or try a room or vibe…',self:'or something like…'};
  let _curChipMode='gift';

  function _buildChips(mode){
    const wrap=document.getElementById('agQuickChips'); if(!wrap) return;
    wrap.innerHTML='';
    (_MODE_CHIPS[mode]||_MODE_CHIPS.gift).forEach(label=>{
      const b=document.createElement('button'); b.className='ag-chip'; b.textContent=label;
      b.addEventListener('click',()=>{
        const inp=document.getElementById('inpF'); if(inp) inp.value=label;
        setTimeout(doAsk,80);
      });
      wrap.appendChild(b);
    });
  }
  /* active RAF handle — single loop drives all 6 rows */
  let _gtRafId=null;
  function _buildGhostTales(mode){
    const wrap=document.getElementById('ghostTales'); if(!wrap) return;
    const lbl=document.getElementById('ghostLbl');
    if(lbl) lbl.textContent=_GHOST_LBL[mode]||'or try one of these';
    if(_gtRafId){cancelAnimationFrame(_gtRafId);_gtRafId=null;}
    wrap.innerHTML='';
    const all=_GHOST_TALES[mode]||_GHOST_TALES.gift;
    const ROWS=6;
    const rowData=Array.from({length:ROWS},(_,i)=>{
      const slice=[];
      for(let j=i;j<all.length;j+=ROWS) slice.push(all[j]);
      return slice.length?slice:all.slice(0,Math.max(1,Math.floor(all.length/ROWS)));
    });

    /* per-row drag state */
    const states=[];

    rowData.forEach((pills)=>{
      const rowWrap=document.createElement('div');
      rowWrap.className='ghost-row-wrap';
      const row=document.createElement('div');
      row.className='ghost-row';

      const makeBtn=(label)=>{
        const b=document.createElement('button');
        b.className='ghost-tale';
        b.textContent=label;
        let _downX=0,_didDrag=false;
        b.addEventListener('pointerdown',e=>{_downX=e.clientX;_didDrag=false;});
        b.addEventListener('pointermove',e=>{if(Math.abs(e.clientX-_downX)>4)_didDrag=true;});
        b.addEventListener('click',()=>{
          if(_didDrag) return;
          const inp=document.getElementById('inpF'); if(inp) inp.value=label;
        });
        return b;
      };
      [...pills,...pills,...pills,...pills].forEach(label=>row.appendChild(makeBtn(label)));
      rowWrap.appendChild(row);
      wrap.appendChild(rowWrap);

      const st={el:rowWrap,isDrag:false,dragX:0,dragScroll:0};
      states.push(st);

      rowWrap.addEventListener('mousedown',e=>{
        st.isDrag=true; st.dragX=e.clientX; st.dragScroll=rowWrap.scrollLeft;
        rowWrap.style.cursor='grabbing'; e.preventDefault();
      });
    });

    /* shared mouse handlers — only one pair on document */
    const onMM=e=>{states.forEach(s=>{if(s.isDrag) s.el.scrollLeft=s.dragScroll-(e.clientX-s.dragX);});};
    const onMU=()=>{states.forEach(s=>{if(s.isDrag){s.isDrag=false;s.el.style.cursor='';}});};
    document.addEventListener('mousemove',onMM);
    document.addEventListener('mouseup',onMU);

    /* store cleanup refs so next rebuild removes old listeners */
    _buildGhostTales._mmRef&&document.removeEventListener('mousemove',_buildGhostTales._mmRef);
    _buildGhostTales._muRef&&document.removeEventListener('mouseup',_buildGhostTales._muRef);
    _buildGhostTales._mmRef=onMM; _buildGhostTales._muRef=onMU;

  }
  function _buildColdState(mode){
    const m=mode||_curChipMode||'gift';
    if(m!==_curChipMode){ _curChipMode=m; }
    _buildChips(m); _buildGhostTales(m);
  }

  /* ═══ LOADING / RESULTS / COLD STATE ORCHESTRATION ═══ */
  const _LOAD_MSGS=[
    'Reading the grain…','Dusting off every shelf…','Holding the chisel a moment…',
    'Walking through the nukkad…','Asking the artisans…','Every tale has a home…',
    'Sniffing fresh sawdust…','Counting the letters…','Looking for the right grain…',
    'The paint is still wet on some…','Matching stories to spaces…',
    'Found some good ones —','Almost there, sizing up the wood…',
    'Gul knows a few that\'ll fit…','Running fingers along the grain…',
  ];
  let _loadCtxExt=null, _loadImgExt=null, _loadMsgTimerExt=null, _loadMsgIdxExt=0;

  function _initLoadCanvas(){
    if(_loadCtxExt) return;
    const cvs=document.getElementById('agLoadGul'); if(!cvs) return;
    _loadCtxExt=cvs.getContext('2d');
    _loadImgExt=new Image();
    _loadImgExt.onload=()=>{
      if(_loadCtxExt) _drawLoadFrame(0);
    };
    _loadImgExt.src=window.NT_GUL_SPR13||'gul-sprite-13f.webp';
  }
  function _drawLoadFrame(f){
    if(!_loadCtxExt||!_loadImgExt||!_loadImgExt.complete) return;
    const fw=_loadImgExt.naturalWidth/13;
    _loadCtxExt.clearRect(0,0,58,58);
    _loadCtxExt.drawImage(_loadImgExt,f*fw,0,fw,_loadImgExt.naturalHeight,0,0,58,58);
  }
  function showLoadingState(q){
    _initLoadCanvas();
    _loadMsgIdxExt=0;
    const msgEl=document.getElementById('agLoadMsg');
    if(msgEl) msgEl.textContent=_LOAD_MSGS[0];
    clearInterval(_loadMsgTimerExt);
    _loadMsgTimerExt=setInterval(()=>{
      _loadMsgIdxExt=(_loadMsgIdxExt+1)%_LOAD_MSGS.length;
      _drawLoadFrame(_loadMsgIdxExt%2===0?3:0);
      if(msgEl) msgEl.textContent=_LOAD_MSGS[_loadMsgIdxExt];
    },680);
    const hd2=document.getElementById('hd'); if(hd2) hd2.classList.add('compact');
    const iw=document.getElementById('idleWrap'); if(iw) iw.style.display='none';
    const lw=document.getElementById('agLoadWrap'); if(lw) lw.classList.add('show');
    const rb=document.getElementById('resBody'); if(rb) rb.style.display='none';
    const cb=document.getElementById('agCtxBar'); if(cb) cb.classList.remove('show');
    const tip=document.getElementById('agTip'); if(tip) tip.classList.remove('show');
    const gr=document.getElementById('resGrid'); if(gr) gr.innerHTML='';
    document.getElementById('panel')?.scrollTo({top:0,behavior:'smooth'});
  }
  let _stockJumpInited=false;
  function _initStockJump(){
    if(_stockJumpInited) return; _stockJumpInited=true;
    const panel=document.getElementById('panel');
    const unlock=document.getElementById('unlock');
    const sj=document.getElementById('stockJump');
    const sjLbl=document.getElementById('stockJumpLbl');
    if(!panel||!unlock||!sj) return;
    panel.addEventListener('scroll',function(){
      /* position of unlock relative to panel viewport + current scrollTop
         gives the scrollTop value at which unlock reaches the top of panel */
      const uTop=unlock.getBoundingClientRect().top
                 -panel.getBoundingClientRect().top
                 +panel.scrollTop;
      const show=panel.scrollTop+60>uTop;
      sj.classList.toggle('show',show);
      if(show&&sjLbl){
        const n=LIVE&&LIVE.matches?LIVE.matches.length:0;
        sjLbl.textContent='back to ₹599+ options'+(n?' · '+n+' results':'');
      }
    },{passive:true});
  }

  function showResultsState(q){
    clearInterval(_loadMsgTimerExt);
    _drawLoadFrame(3);
    const hd2=document.getElementById('hd'); if(hd2) hd2.classList.add('compact');
    const lw=document.getElementById('agLoadWrap'); if(lw) lw.classList.remove('show');
    const rb=document.getElementById('resBody'); if(rb) rb.style.display='block';
    const iw=document.getElementById('idleWrap'); if(iw) iw.style.display='none';
    const ctxQ=document.getElementById('agCtxQ'); if(ctxQ&&q) ctxQ.textContent=q;
    const ctxBar=document.getElementById('agCtxBar'); if(ctxBar) ctxBar.classList.add('show');
    const tip=document.getElementById('agTip'); if(tip) tip.classList.add('show');
    const sj=document.getElementById('stockJump'); if(sj) sj.classList.remove('show');
    _initStockJump();
  }
  function showColdState(){
    clearInterval(_loadMsgTimerExt);
    const hd2=document.getElementById('hd'); if(hd2) hd2.classList.remove('compact');
    const lw=document.getElementById('agLoadWrap'); if(lw) lw.classList.remove('show');
    const rb=document.getElementById('resBody'); if(rb) rb.style.display='none';
    const cb=document.getElementById('agCtxBar'); if(cb) cb.classList.remove('show');
    const tip=document.getElementById('agTip'); if(tip) tip.classList.remove('show');
    const iw=document.getElementById('idleWrap'); if(iw) iw.style.display='';
  }

  /* ═══ INTRO ═══ */
  let _dismissT = null;
  function playIntro(){
    _bigActive = true;
    _bigCvs = document.getElementById('gulBigCvs');
    const overlay=document.getElementById('gulOverlay');
    requestAnimationFrame(()=>overlay.classList.add('active'));
    setTimeout(()=>typeText(INTRO_TXT,()=>{ _dismissT=setTimeout(dismissGul,2200); }),480);
  }
  function dismissGul(){
    clearTimeout(_dismissT); clearTimeout(typT);
    _bigActive=false;
    document.getElementById('gulOverlay').classList.remove('active');
  }

  /* ═══ OPEN HOOK — called by openAg() when the drawer is inline ═══ */
  let _spriteReady=false;
  function ntAgOpen(intent, q){
    showColdState();
    if(intent) intentTap(intent);
    _buildColdState(intent||_curChipMode);

    if(q){
      /* Show loading animation immediately as drawer slides open */
      document.getElementById('inpF').value=q;
      showLoadingState(q);
      setTimeout(()=>doAsk(),260);
    } else {
      setTimeout(function(){ var inp=document.getElementById('inpF'); if(inp) inp.focus(); },300);
    }
  }

  /* ═══ EXPOSE for onclick handlers in section markup ═══ */

  /* agGoBack — resets drawer to cold/search state; called by the "Change →" button.
     Defined here (external file) so it's always available regardless of whether the
     drawer's inline snippet script runs (Foxify may block inline section scripts). */
  function agGoBack() {
    var hd = document.getElementById('hd');
    if (hd) hd.classList.remove('compact');
    var lw = document.getElementById('agLoadWrap');
    if (lw) lw.classList.remove('show');
    var rb = document.getElementById('resBody');
    if (rb) rb.style.display = 'none';
    var cb = document.getElementById('agCtxBar');
    if (cb) cb.classList.remove('show');
    var tip = document.getElementById('agTip');
    if (tip) tip.classList.remove('show');
    var iw = document.getElementById('idleWrap');
    if (iw) iw.style.display = '';
    var p = document.getElementById('panel');
    if (p) p.scrollTo({top: 0, behavior: 'smooth'});
    setTimeout(function() {
      var inp = document.getElementById('inpF');
      if (inp) { inp.focus(); inp.select(); }
    }, 300);
  }

  Object.assign(window, {
    intentTap, doAsk, pipTap, dismissGul, flash,
    goTop, goAddName, openEditor, showMoreQuotes, showMoreTales, focusSearch,
    openSaved, closeSheet, openBag, closeBag, restoreTab,
    openVariant, closeVariant, varQty, confirmBag, openPolicy,
    proceedCart, restoreHist, ntAgOpen, agGoBack,
    showLoadingState, showResultsState, showColdState,
    agReopen:_agReopen
  });

  /* ═══ INIT ═══ */
  function init(){
    const panel=document.getElementById('panel'), hd=document.getElementById('hd');
    if(!panel || !hd){ setTimeout(init, 60); return; }

    /* Re-parent both overlay and sheet to <body> so no Foxify section wrapper
       (which may have transforms) can break position:fixed viewport anchoring. */
    const hostOverlay=document.getElementById('agOverlay');
    if(hostOverlay && hostOverlay.parentElement !== document.body){
      document.body.appendChild(hostOverlay);
    }
    const hostSheet=document.querySelector('.ag-sheet');
    if(hostSheet && hostSheet.parentElement !== document.body){
      document.body.appendChild(hostSheet);
    }

    /* scroll squeeze + floating go-top circle — hysteresis prevents layout jump:
       collapse at 60px, restore at 18px so rapid scroll doesn't toggle mid-flight */
    let _hdShrunk=false;
    panel.addEventListener('scroll',()=>{
      const st=panel.scrollTop;
      if(!_hdShrunk&&st>60){_hdShrunk=true;hd.classList.add('shrunk');}
      else if(_hdShrunk&&st<18){_hdShrunk=false;hd.classList.remove('shrunk');}
      document.getElementById('scrollTip').classList.toggle('show',st>60);
      const hasRes=document.getElementById('unlock').classList.contains('show');
      document.getElementById('botbar').classList.toggle('show', hasRes);
      const goTopBtn=document.getElementById('goTopBtn');
      if(goTopBtn) goTopBtn.classList.toggle('show', st>120);
    },{passive:true});

    updWish(); updBag(); renderHist(); setHint('default'); renderTabBar();
    _buildColdState('gift');

    /* Re-build chips+ghost when mode changes (intentTap toggles .on on mode buttons) */
    const _modeRow=document.getElementById('intentRow');
    if(_modeRow) new MutationObserver(()=>{
      const on=_modeRow.querySelector('.ag-mode-btn.on');
      if(!on) return;
      const m=on.id==='ic-gift'?'gift':on.id==='ic-decor'?'decor':'self';
      if(m!==_curChipMode){_curChipMode=m;_buildChips(m);_buildGhostTales(m);}
    }).observe(_modeRow,{attributes:true,subtree:true,attributeFilter:['class']});

    const img=new Image();
    img.onload=()=>{
      gulImg=img;
      _miniCvs=document.getElementById('gulMiniCvs');
      _spriteReady=true;
      startLoop();
    };
    img.src=window.NT_GUL_SPR13 || 'gul-sprite-13f.webp';

    if(!embedded){
      if(INIT_INTENT) intentTap(INIT_INTENT);
      if(INIT_Q){document.getElementById('inpF').value=INIT_Q;setTimeout(()=>doAsk(),260);}
    }

    // Warm the Anthropic prompt cache when user focuses the search box
    const _inpF=document.getElementById('inpF');
    if(_inpF) _inpF.addEventListener('focus',()=>{
      fetch(NT_API_URLS[0],{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query:'gift'})}).catch(()=>{});
    },{once:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Customise section — runs on all pages (Foxify blocks the inline IIFE in the section) */
(function(){
  function buildCustomise(){
    var cutIn=document.getElementById('sayInput');
    var cutEl=document.getElementById('cutout');
    if(!cutIn||!cutEl) return;
    var CUSTEX=window.NT_CUSTEX||['Sabse pyaare papa','Ghar sweet ghar','Param Mitr','Apna time aayega','Khush raho','Maa'];
    var cxi=0, cxT=null;
    cutEl.textContent=CUSTEX[0];
    if(!cxT) cxT=setInterval(function(){
      if(cutIn.value.trim()) return;
      cxi=(cxi+1)%CUSTEX.length;
      cutEl.classList.add('swap');
      setTimeout(function(){ cutEl.textContent=CUSTEX[cxi]; cutEl.classList.remove('swap'); },300);
    },2200);
    cutIn.addEventListener('input',function(){
      cutIn.style.height='auto';
      cutIn.style.height=cutIn.scrollHeight+'px';
      cutEl.textContent=cutIn.value.trim()||CUSTEX[cxi];
    });
  }
  window.sayGo=window.ntSayGo=function(){
    var cutIn=document.getElementById('sayInput');
    /* Only use what the user actually typed — never use the rotating placeholder */
    var v=((cutIn&&cutIn.value)||'').trim();
    if(!window.ntOpenSlider) return;
    if(v) sessionStorage.setItem('nt_landing_text',v);
    else sessionStorage.setItem('nt_skip_welcome','1');
    ntOpenSlider('customise');
  };
  window.ntBuildCustomise=buildCustomise;
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',buildCustomise);
  } else {
    buildCustomise();
  }
})();

/* Ask Gul drawer host — available on ALL pages (nukkad-home.js only runs on index) */
(function(){
  'use strict';

  function modeData(){
    var el=document.getElementById('agModes');
    if(!el) return null;
    var d=el.dataset;
    function split(s){ return (s||'').split(',').map(function(x){return x.trim();}).filter(Boolean); }
    return {
      gift:  { prefix: d.giftPrefix||'A gift for', ph: d.giftPh||'',  pills: split(d.giftPills)  },
      decor: { prefix: d.decorPrefix||'For my',    ph: d.decorPh||'', pills: split(d.decorPills) },
      self:  { prefix: '',                          ph: d.selfPh||'',  pills: split(d.selfPills)  }
    };
  }

  function activeIntent(){
    var el=document.querySelector('.agt-tile.on,.m-tile.on');
    if(el){
      var m=(el.getAttribute('onclick')||'').match(/'(\w+)'/);
      if(m) return m[1];
    }
    return 'gift';
  }

  var _agScrollY=0;

  window.openAg=function(intent,qOverride){
    var ov=document.getElementById('agOverlay');
    if(!ov) return;
    if(!window._gulCalledThisSession){window._gulCalledThisSession=true;window._trackGulEvent('call');}
    var ciEl=document.getElementById('ci');
    var q=(qOverride!=null?qOverride:(ciEl?ciEl.value:'')||'').trim();
    var it=intent||activeIntent();
    _agScrollY=window.scrollY||window.pageYOffset||0;
    if(ov.parentElement!==document.body) document.body.appendChild(ov);
    var sheet=document.querySelector('.ag-sheet');
    if(sheet&&sheet.parentElement!==document.body) document.body.appendChild(sheet);
    ov.classList.add('open');
    document.body.classList.add('ag-open');
    if(sheet) sheet.classList.add('open');
    var bbl=document.getElementById('nt-bubble');
    if(bbl) bbl.style.visibility='hidden';
    if(typeof window.ntAgOpen==='function') window.ntAgOpen(it,q);
  };

  window.closeAg=function(){
    var ov=document.getElementById('agOverlay');
    if(ov) ov.classList.remove('open');
    document.body.classList.remove('ag-open');
    var sheet=document.querySelector('.ag-sheet');
    if(sheet) sheet.classList.remove('open');
    var bbl=document.getElementById('nt-bubble');
    if(bbl) bbl.style.visibility='';
    window.scrollTo(0,_agScrollY);
  };

  window.agtMode=window.ntAgtMode=function(k){
    document.querySelectorAll('.agt-tile,.m-tile').forEach(function(t){
      t.classList.toggle('on',(t.getAttribute('onclick')||'').indexOf("'"+k+"'")>-1);
    });
    var MODES=modeData();
    var M=MODES&&MODES[k];
    if(!M) return;
    var chip=document.getElementById('agtChip');
    var inp=document.getElementById('ci');
    if(k==='self'){
      if(chip) chip.classList.remove('show');
    } else if(chip){
      chip.textContent=M.prefix;
      chip.classList.add('show');
    }
    if(inp) inp.placeholder=M.ph;
    var pills=document.getElementById('pills');
    if(pills) pills.innerHTML=M.pills.map(function(p){
      return '<button class="pill" onclick="pillGo(\''+p.replace(/'/g,'')+'\')">' + p + '</button>';
    }).join('');
  };

  window.pillGo=window.ntPillGo=function(label){
    var inp=document.getElementById('ci');
    if(inp){ inp.value=label+', '; }
    if(typeof window.openAg==='function') window.openAg();
  };
})();

/* Animate the Ask Gul trigger avatar on any page (collection, product, home) */
(function initAgtGul(){
  if(!window.makeGul){ setTimeout(initAgtGul,100); return; }
  try{
    var av=document.getElementById('askGulAv');
    if(!av) return;
    var g=window.makeGul(av,56);
    if(!g) return;
    var F=window.F||{closed:0,blink:2};
    g.setFace(F.closed||0);
    window._ntAskGul=g;
    setInterval(function(){
      g.frame(F.blink||2);
      setTimeout(function(){ g.frame(g.base); },150);
    }, 3400+Math.random()*1400);
  }catch(e){}
})();
